/**
 * Fullscreen triangle vertex shader, shared by every fragment shader in the
 * editor. Generates three vertices from `gl_VertexID` that cover the
 * [-1, 1] × [-1, 1] NDC region with one oversized triangle — no VBO, no
 * vertex attributes, and avoids the diagonal-seam artifact you can get
 * sampling a fullscreen quad.
 *
 * v_texCoord is the UV passed to the fragment shader, with the Y axis
 * flipped so it matches image-space (origin top-left).
 */

export const VERTEX_SHADER = /* glsl */ `#version 300 es

out vec2 v_texCoord;

void main() {
  float x = float(gl_VertexID & 1);
  float y = float((gl_VertexID >> 1) & 1);
  gl_Position = vec4(x * 4.0 - 1.0, y * 4.0 - 1.0, 0.0, 1.0);
  v_texCoord = vec2(x * 2.0, 1.0 - y * 2.0);
}
`;
